import type { RouterConfig, SelfHelpRouteName } from '../../containers/Routes/types';

// Pages.
import PageAccountAvatar from './Avatar';
import PageAccountBuddies from './Buddies';
import PageAccountChangeEmail from './ChangeEmail';
import PageAccountChangePassword from './ChangePassword';
import PageAccountMessages from './Messages';
import PageAccountNursePractitioner from './NursePracticioner';
import PageAccountSetting from './Settings';

const routesConfigAccount: RouterConfig<SelfHelpRouteName> = {
  accountAvatar: {
    basePath: '/account/mijn-avatar',
    nl: '/nl/account/mijn-avatar',
    en: '/en/account/my-avatar',
    type: 'private',
    component: PageAccountAvatar,
  },
  accountBase: {
    basePath: '/account',
    nl: '/nl/account',
    en: '/en/account',
    type: 'private',
    component: PageAccountSetting,
  },
  accountBuddies: {
    basePath: '/account/buddies',
    nl: '/nl/account/buddies',
    en: '/en/account/buddies',
    type: 'private',
    component: PageAccountBuddies,
  },
  accountEmail: {
    basePath: '/account/email-wijzigen',
    nl: '/nl/account/email-wijzigen',
    en: '/en/account/change-email',
    type: 'private',
    component: PageAccountChangeEmail,
  },
  accountMessages: {
    basePath: '/account/meldingen',
    nl: '/nl/account/meldingen',
    en: '/en/account/notifications',
    type: 'private',
    component: PageAccountMessages,
  },
  accountNursePractitioner: {
    basePath: '/account/mijn-poh',
    nl: '/nl/account/mijn-poh',
    en: '/en/account/my-nurse-practitioner',
    type: 'private',
    component: PageAccountNursePractitioner,
  },
  accountPassword: {
    basePath: '/account/wachtwoord-wijzigen',
    nl: '/nl/account/wachtwoord-wijzigen',
    en: '/en/account/change-password',
    type: 'private',
    component: PageAccountChangePassword,
  },
};

export default routesConfigAccount;
